import React, { useState, useEffect } from "react";
import axios from "axios";
import style from "./Showinventory.module.css";
import { Inventory_api } from "../../../Apiconfig";
import { ReactTransliterate } from "react-transliterate";



const Showinventory = () => {
  const [inventoryData, setInventoryData] = useState([]); // Store inventory data
  const [loading, setLoading] = useState(true); // Track loading state
  const [error, setError] = useState(null); // Track errors
  const [page, setPage] = useState(1); // Track the current page for lazy loading
  const [isLoading, setIsLoading] = useState(false); // Track if a request is in progress
   const [currentPage, setCurrentPage] = useState(0);
  const [editingRow, setEditingRow] = useState(null);
  const [editedValues, setEditedValues] = useState({});

    const [hasMore, setHasMore] = useState(true); // Default: true

  const [searchResults, setSearchResults] = useState([]); // Search results data
  const [searchQuery, setSearchQuery] = useState(""); // Track the search query
  // nancy
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("all");

  const [language, setLanguage] = useState("en")


  // fetch category by dropdown 

  useEffect(() => {
    fetchCategories();
    fetchInventory(page, selectedCategory); // Fetch inventory with category filter
  }, [page, selectedCategory]); // Dependency array includes selectedCategory

  const fetchCategories = async () => {
    try {
      const response = await axios.get(`${Inventory_api}/SelectCategoryDropdown.php`, {
        withCredentials: true,
      });
      if (response.data && response.data.categories) {
        setCategories([{ id: "all", name: "All" }, ...response.data.categories]);
      }
    } catch (err) {
      console.error("Failed to fetch categories", err);
    }
  };

  const handleCategoryChange = (e) => {
    setSelectedCategory(e.target.value);
    setInventoryData([]);  // Clear existing data
    setPage(1);  // Reset to page 1
  };


  // Fetch inventory data from the backend
  const fetchInventory = async (pageNumber, category = "all") => {
    if (isLoading  || !hasMore) return;

    setIsLoading(true);
    setCurrentPage(pageNumber);
    try {
      const response = await axios.get(`${Inventory_api}/fetch_inventory.php`, {
        params: { page: pageNumber, category: category },
        withCredentials: true,
      });

      if (response.data && response.data.length > 0) {
        setInventoryData((prevData) => {
          const newData = response.data.filter(
            (item) => !prevData.some((existing) => existing.id === item.id)
          );
          return [...prevData, ...newData];
        });
      }else {
        setHasMore(false); // No more data
      }
      setLoading(false);
      setIsLoading(false);
    } catch (err) {
      setError("Failed to fetch inventory data");
      setLoading(false);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchInventory(page); // Fetch inventory when the component mounts
  }, [page]);


  // Search inventory data
  const handleSearch = async (query) => {
    setSearchQuery(query);
    if (query.trim().length < 3) {
      setSearchResults([]); // Clear search results if query is empty
      return;
    }

    try {
      const response = await axios.get(`${Inventory_api}/SearchProductByDetails.php`, {
        params: { search: query },
        withCredentials: true,
      });

      if (response.data && response.data.products) {
        setSearchResults(response.data.products);
      } else {
        setSearchResults([]);
      }
    } catch (err) {
      console.error("Failed to fetch search results:", err);
    }
  };



  // Handle scroll to load more data
  const handleScroll = (e) => {
    const bottom = e.target.scrollTop + e.target.clientHeight >= e.target.scrollHeight - 20; // Add tolerance for precision
    if (bottom) {
      setPage((prevPage) => prevPage + 1); // Increment page number
    }
  };


  const handleEdit = (id) => {
    setEditingRow(id);
    const item = inventoryData.find((data) => data.id === id);
    setEditedValues(item);
  };

  const handleInputChange = (e, field) => {
    setEditedValues({ ...editedValues, [field]: e.target.value });
  };

  const saveEdit = async (id) => {
    try {
      await axios.post(`${Inventory_api}/edit_product.php`, editedValues, {
        withCredentials: true,
      });
      setEditingRow(null);
      fetchInventory();
    } catch (err) {
      console.error("Error saving changes:", err);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this item?")) {
      console.log(id);
      try {
        await axios.post(
          `${Inventory_api}/delete_product.php`,
          { id },
          {
            withCredentials: true,
          }
        );
        fetchInventory();
      } catch (err) {
        console.error("Error deleting record:", err);
      }
    }
  };



  // Render loading state
  if (loading && page === 1) {
    return <p>Loading inventory data...</p>;
  }

  // Render error message
  if (error) {
    return <p className={style.errorMessage}>{error}</p>;
  }


  // Render inventory table
  return (
    <>

      <div className="row align-items-center m-0">

        <div className="col-md-6 mb-2">
          <div className={`row ${style.searchFieldSection}`}>
            <div className="col-auto pe-0">
              <select
                value={language}
                onChange={(e) => setLanguage(e.target.value)}
                className={`${style.languageSelector} form-select`}
              >
                <option value="en">English</option>
                <option value="hi">Hindi</option>
                <option value="ta">Tamil</option>
                <option value="bn">Bengali</option>
                <option value="gu">Gujarati</option>
              </select>
            </div>

            <div className="col ps-0">
              <ReactTransliterate
                value={searchQuery}
                onChangeText={(text) => {

                  handleSearch(text);
                }}
                lang={language}
                className={`${style.searchField} form-control`}
                placeholder="SEARCH BY NAME & CODE"
                onChange={(e) => handleSearch(e.target.value)}
              />
            </div>
          </div>
        </div>


        <div className="col-md-6 mb-2">
          <select
            className="form-select"
            value={selectedCategory}
            onChange={handleCategoryChange}
          >
            {categories.map((category) => (
              <option key={category.id} value={category.id}>
                {category.name}
              </option>
            ))}
          </select>
        </div>

      </div>



      <div
        onScroll={handleScroll}
        className={`${style.inventoryContainer} px-3`}
        style={{ height: '440px', overflowY: 'auto' }} // Ensure container is scrollable
      >
        <div className="table-responsive">
          <table className={`${style.inventoryTable} table table-striped`}>
            <thead className={`${style.inventoryTableHead}`}>
              <tr>
                <th className={style.addedtableheadaaa}>ID</th>
                <th className={style.addedtableheadaaa}>NAME</th>
                <th className={style.addedtableheadaaa}>NAME 2</th>
                <th className={style.addedtableheadaaa}>NAME 3</th>
                <th className={style.addedtableheadaaa}>HINDI NAME</th>
                <th className={style.addedtableheadaaa}>HINDI NAME 2</th>
                <th className={style.addedtableheadaaa}>HINDI NAME 3</th>
                <th className={style.addedtableheadaaa}>LOCAL NAME</th>
                <th className={style.addedtableheadaaa}>LOCAL NAME 2</th>
                <th className={style.addedtableheadaaa}>LOCAL NAME 3</th>
                <th className={style.addedtableheadaaa}>MRP</th>
                <th className={style.addedtableheadaaa}>QUANTITY</th>
                <th className={style.addedtableheadaaa}>WEIGHT</th>
                <th className={style.addedtableheadaaa}>UNIT PRICE</th>
                <th className={style.addedtableheadaaa}>SELL PRICE</th>
                <th className={style.addedtableheadaaa}>DISCOUNT</th>
                <th className={style.addedtableheadaaa}>SKU</th>
                <th className={style.addedtableheadaaa}>CODE</th>
                <th className={style.addedtableheadaaa}>EXPIRY</th>
                <th className={style.addedtableheadaaa}>CATEGORY</th>
                <th className={style.addedtableheadaaa}>TYPE 1</th>
                <th className={style.addedtableheadaaa}>TYPE 2</th>
                <th className={style.addedtableheadaaa}>TYPE 3</th>
                <th className={style.addedtableheadaaa}>TYPE 4</th>
                <th className={style.addedtableheadaaa}>RACK NO.</th>
                <th className={style.addedtableheadaaa}>WAREHOUSE</th>
                <th className={style.addedtableheadaaa}>BATCH NO.</th>
                <th className={style.addedtableheadaaa}>TRANSPORT</th>
                <th className={style.addedtableheadaaa}>Created</th>
                <th className={style.addedtableheadaaa}>ACTIONS</th>
              </tr>
            </thead>
            <tbody>
              {(searchQuery ? searchResults : inventoryData).map((item) => (
                <tr key={item.id}>
                  <td>{item.id}</td>
                  <td>
                    {editingRow === item.id ? (
                      <input
                        className={style.inputfield}
                        value={editedValues.product_name || ""}
                        onChange={(e) => handleInputChange(e, "product_name")}
                      />
                    ) : (
                      item.product_name
                    )}
                  </td>
                  <td>
                    {editingRow === item.id ? (
                      <input
                        className={style.inputfield}
                        value={editedValues.product_name2 || ""}
                        onChange={(e) => handleInputChange(e, "product_name2")}
                      />
                    ) : (
                      item.product_name2
                    )}
                  </td>
                  <td>
                    {editingRow === item.id ? (
                      <input
                        className={style.inputfield}
                        value={editedValues.product_name3 || ""}
                        onChange={(e) => handleInputChange(e, "product_name3")}
                      />
                    ) : (
                      item.product_name3
                    )}
                  </td>
                  <td>
                    {editingRow === item.id ? (
                      <input
                        className={style.inputfield}
                        value={editedValues.hindi_name || ""}
                        onChange={(e) => handleInputChange(e, "hindi_name")}
                      />
                    ) : (
                      item.hindi_name
                    )}
                  </td>
                  <td>
                    {editingRow === item.id ? (
                      <input
                        className={style.inputfield}
                        value={editedValues.hindi_name2 || ""}
                        onChange={(e) => handleInputChange(e, "hindi_name2")}
                      />
                    ) : (
                      item.hindi_name2
                    )}
                  </td>
                  <td>
                    {editingRow === item.id ? (
                      <input
                        className={style.inputfield}
                        value={editedValues.hindi_name3 || ""}
                        onChange={(e) => handleInputChange(e, "hindi_name3")}
                      />
                    ) : (
                      item.hindi_name3
                    )}
                  </td>
                  <td>
                    {editingRow === item.id ? (
                      <input
                        className={style.inputfield}
                        value={editedValues.local_name || ""}
                        onChange={(e) => handleInputChange(e, "local_name")}
                      />
                    ) : (
                      item.local_name
                    )}
                  </td>
                  <td>
                    {editingRow === item.id ? (
                      <input
                        className={style.inputfield}
                        value={editedValues.local_name2 || ""}
                        onChange={(e) => handleInputChange(e, "local_name2")}
                      />
                    ) : (
                      item.local_name2
                    )}
                  </td>
                  <td>
                    {editingRow === item.id ? (
                      <input
                        className={style.inputfield}
                        value={editedValues.local_name3 || ""}
                        onChange={(e) => handleInputChange(e, "local_name3")}
                      />
                    ) : (
                      item.local_name3
                    )}
                  </td>
                  <td>
                    {editingRow === item.id ? (
                      <input
                        className={style.inputfield}
                        value={editedValues.product_mrp || ""}
                        onChange={(e) => handleInputChange(e, "product_mrp")}
                      />
                    ) : (
                      item.product_mrp
                    )}
                  </td>
                  <td>
                    {editingRow === item.id ? (
                      <input
                        className={style.inputfield}
                        value={editedValues.product_quantity || ""}
                        onChange={(e) =>
                          handleInputChange(e, "product_quantity")
                        }
                      />
                    ) : (
                      item.product_quantity
                    )}
                  </td>
                  <td>
                    {editingRow === item.id ? (
                      <input
                        className={style.inputfield}
                        value={editedValues.product_weight || ""}
                        onChange={(e) => handleInputChange(e, "product_weight")}
                      />
                    ) : (
                      item.product_weight
                    )}
                  </td>
                  {/* <td>{item.product_weight}</td> */}
                  <td>
                    {editingRow === item.id ? (
                      <input
                        className={style.inputfield}
                        value={editedValues.buy_price || ""}
                        onChange={(e) => handleInputChange(e, "buy_price")}
                      />
                    ) : (
                      item.buy_price
                    )}
                  </td>
                  {/* <td>{item.buy_price}</td> */}
                  <td>
                    {editingRow === item.id ? (
                      <input
                        className={style.inputfield}
                        value={editedValues.sale_price || ""}
                        onChange={(e) => handleInputChange(e, "sale_price")}
                      />
                    ) : (
                      item.sale_price
                    )}
                  </td>
                  {/* <td>{item.sale_price}</td> */}
                  <td>
                    {editingRow === item.id ? (
                      <input
                        className={style.inputfield}
                        value={editedValues.product_discount || ""}
                        onChange={(e) =>
                          handleInputChange(e, "product_discount")
                        }
                      />
                    ) : (
                      item.product_discount
                    )}
                  </td>
                  {/* <td>{item.product_discount}</td> */}
                  <td>
                    {editingRow === item.id ? (
                      <input
                        className={style.inputfield}
                        value={editedValues.product_sku || ""}
                        onChange={(e) => handleInputChange(e, "product_sku")}
                      />
                    ) : (
                      item.product_sku
                    )}
                  </td>
                  {/* <td>{item.product_sku}</td> */}
                  <td>
                    {editingRow === item.id ? (
                      <input
                        className={style.inputfield}
                        value={editedValues.product_code || ""}
                        onChange={(e) => handleInputChange(e, "product_code")}
                      />
                    ) : (
                      item.product_code
                    )}
                  </td>
                  {/* <td>{item.product_code}</td> */}
                  <td>
                    {editingRow === item.id ? (
                      <input
                        className={style.inputfield}
                        value={editedValues.product_expiry_date || ""}
                        onChange={(e) =>
                          handleInputChange(e, "product_expiry_date")
                        }
                      />
                    ) : (
                      item.product_expiry_date
                    )}
                  </td>
                  {/* <td>{item.product_expiry_date}</td> */}
                  <td>
                    {editingRow === item.id ? (
                      <input
                        className={style.inputfield}
                        value={editedValues.product_category || ""}
                        onChange={(e) =>
                          handleInputChange(e, "product_category")
                        }
                      />
                    ) : (
                      item.product_category
                    )}
                  </td>
                  {/* <td>{item.product_category}</td> */}
                  <td>
                    {editingRow === item.id ? (
                      <input
                        className={style.inputfield}
                        value={editedValues.product_type1 || ""}
                        onChange={(e) => handleInputChange(e, "product_type1")}
                      />
                    ) : (
                      item.product_type1
                    )}
                  </td>
                  {/* <td>{item.product_type1}</td> */}
                  <td>
                    {editingRow === item.id ? (
                      <input
                        className={style.inputfield}
                        value={editedValues.product_type2 || ""}
                        onChange={(e) => handleInputChange(e, "product_type2")}
                      />
                    ) : (
                      item.product_type2
                    )}
                  </td>
                  {/* <td>{item.product_type2}</td> */}
                  <td>
                    {editingRow === item.id ? (
                      <input
                        className={style.inputfield}
                        value={editedValues.product_type3 || ""}
                        onChange={(e) => handleInputChange(e, "product_type3")}
                      />
                    ) : (
                      item.product_type3
                    )}
                  </td>
                  {/* <td>{item.product_type3}</td> */}
                  <td>
                    {editingRow === item.id ? (
                      <input
                        className={style.inputfield}
                        value={editedValues.product_type4 || ""}
                        onChange={(e) => handleInputChange(e, "product_type4")}
                      />
                    ) : (
                      item.product_type4
                    )}
                  </td>
                  {/* <td>{item.product_type4}</td> */}
                  <td>
                    {editingRow === item.id ? (
                      <input
                        className={style.inputfield}
                        value={editedValues.product_rack_no || ""}
                        onChange={(e) =>
                          handleInputChange(e, "product_rack_no")
                        }
                      />
                    ) : (
                      item.product_rack_no
                    )}
                  </td>
                  {/* <td>{item.product_rack_no}</td> */}
                  <td>
                    {editingRow === item.id ? (
                      <input
                        className={style.inputfield}
                        value={editedValues.warehouse_location || ""}
                        onChange={(e) =>
                          handleInputChange(e, "warehouse_location")
                        }
                      />
                    ) : (
                      item.warehouse_location
                    )}
                  </td>
                  {/* <td>{item.warehouse_location}</td> */}
                  <td>
                    {editingRow === item.id ? (
                      <input
                        className={style.inputfield}
                        value={editedValues.batch_no || ""}
                        onChange={(e) => handleInputChange(e, "batch_no")}
                      />
                    ) : (
                      item.batch_no
                    )}
                  </td>
                  {/* <td>{item.batch_no}</td> */}
                  <td>
                    {editingRow === item.id ? (
                      <input
                        value={editedValues.transport_charge || ""}
                        onChange={(e) =>
                          handleInputChange(e, "transport_charge")
                        }
                      />
                    ) : (
                      item.transport_charge
                    )}
                  </td>
                  {/* <td>{item.transport_charge}</td> */}
                  <td>{item.created_at}</td>
                  <td>
                    {editingRow === item.id ? (
                      <>
                        <button
                          className={style.actionrowbtns}
                          onClick={() => saveEdit(item.id)}
                        >
                          Save
                        </button>
                        <button
                          className={style.actionrowbtns}
                          onClick={() => setEditingRow(null)}
                        >
                          Cancel
                        </button>
                      </>
                    ) : (
                      <>
                        {/* <div className={`${style.actionbtnrow} row`}> */}
                        <button
                          className={style.actionrowbtns}
                          onClick={() => handleEdit(item.id)}
                        >
                          Edit
                        </button>
                        <button
                          className={style.actionrowbtns}
                          onClick={() => handleDelete(item.id)}
                        >
                          Delete
                        </button>
                        {/* </div> */}
                      </>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {isLoading && <p>Loading more data...</p>}
        </div>
      </div>
    </>
  );
};

export default Showinventory;
